import { render, staticRenderFns } from "./SalesSuppliers.vue?vue&type=template&id=4d965130&scoped=true&"
import script from "./SalesSuppliers.vue?vue&type=script&lang=js&"
export * from "./SalesSuppliers.vue?vue&type=script&lang=js&"
import style0 from "./SalesSuppliers.vue?vue&type=style&index=0&id=4d965130&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d965130",
  null
  
)

export default component.exports